import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCategory: null,
};

const homePageControlSlice = createSlice({
  name: "homePageControl",
  initialState: initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      const { id } = action.payload;
      state.selectedCategory = id;
    },
    clearSelectedCategory: (state, action) => {
      state.selectedCategory = "";
    },
  },
});

export const { setSelectedCategory, clearSelectedCategory } = homePageControlSlice.actions;
export default homePageControlSlice.reducer;
